import {inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {EnvironmentService} from '@services/enviroment/environment.service';
import {BehaviorSubject, catchError, map, Observable, of, tap} from 'rxjs';

@Injectable({providedIn: 'root'})
export class LoginService {
  private http = inject(HttpClient);
  private apiUrl = inject(EnvironmentService).getValue('apiUrl');
  private accessToken: string | null = null;
  private userSubject = new BehaviorSubject<any>(null);
  readonly user$ = this.userSubject.asObservable();

  loginUser(email: string, password: string) {
    return this.http.post<any>(`${this.apiUrl}/v1/staff/auth/login`, {email, password}, {withCredentials: true}).pipe(
      tap(result => this.acceptSession(result)), map(result => result.user));
  }

  restoreSession(): Observable<boolean> {
    return this.http.post<any>(`${this.apiUrl}/v1/staff/auth/refresh`, {}, {withCredentials: true}).pipe(
      tap(result => this.acceptSession(result)), map(() => true), catchError(() => { this.clearSession(); return of(false); }));
  }

  refreshSession() { return this.restoreSession(); }
  getToken() { return this.accessToken; }
  getUser() { return this.userSubject.value; }
  isUserLoggedIn() { return !!this.userSubject.value && !!this.accessToken; }
  getUserRole() { return this.userSubject.value?.role ?? null; }

  acceptSession(result: any) {
    this.accessToken = result.access_token;
    this.userSubject.next(result.user);
  }

  logoutUser() {
    this.http.post(`${this.apiUrl}/v1/staff/auth/logout`, {}, {withCredentials: true}).subscribe({error: () => undefined});
    this.clearSession();
  }
  clearSession() { this.accessToken = null; this.userSubject.next(null); }
}
